import { FetchResponseFormat, HTTPResponseError, IBaseFetchRequestConfig, IBaseFetchType } from '@/types/network/common'
import { getApiDomain } from '@/utils/general/url'
// eslint-disable-next-line import/order
import { commonHeaders, getUnifiedHeader } from '@/constants/network'
import { getCookie } from '@/utils/general/cookie'
import { FEATURE_COOKIE_NAME } from '@/constants/browser'
import { isServer } from '@/utils/general'

/**
 *
 * @param url API end point for request
 * @param method Request Method GET,POST,PUT,DELETE
 * @param body Request Body payload
 * @param headers Requst headers
 * @param responseType Response data type can be three types JSON,TEXT or RAW
 *                     since response can be of multiple type like ArrayBUffer for image or PDF raw data,
 *                     Default value is JSON
 * @returns ResponseType
 */
const baseFetch: IBaseFetchType = async <ResponseType = unknown>(requestConfig: IBaseFetchRequestConfig) => {
    const { url, method, body, headers, responseType, domain = getApiDomain(url) } = requestConfig

    // Read feature cookie from browser (only on client-side)
    const featureCookieValue = !isServer() ? getCookie(FEATURE_COOKIE_NAME) || '' : ''

    // Build headers object with feature cookie if it exists
    const requestHeaders: HeadersInit = {
        ...commonHeaders,
        ...headers,
        'x-unified-header': JSON.stringify(getUnifiedHeader()),
        'app-agent': 'DESKTOP',
        ...(featureCookieValue && { [FEATURE_COOKIE_NAME]: featureCookieValue }),
    }

    const config: RequestInit = {
        method,
        body,
        headers: requestHeaders,
    }
    const requestUrl = `${domain}${url}`

    const response = await fetch(requestUrl, config)

    if (response.ok) {
        switch (responseType) {
            case FetchResponseFormat.TEXT:
                return response.text()
            case FetchResponseFormat.RAW:
                return response
            case FetchResponseFormat.JSON:
            default:
                return response.json() as ResponseType
        }
    } else {
        const errorResponse = await response.json()
        throw new HTTPResponseError(response, errorResponse)
    }
}

export default baseFetch
